module.exports = __webpack_public_path__ + "way2go/static/config/arrow_white.png";